"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _UserName = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserName"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _utils = require("@insided/deprecated-preact-components/leaderboard/utils");

var _insidedDataStorage = require("@insided/shared/utils/insidedDataStorage");

var _Medal = _interopRequireDefault(require("@insided/destination/icons/Medal"));

var _ChevronRight = _interopRequireDefault(require("@insided/shared/icons/ChevronRight"));

var _classnames = _interopRequireDefault(require("classnames"));

var _axios = _interopRequireDefault(require("axios"));

var _qs = _interopRequireDefault(require("qs"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var minUsersRequiredOnLeaderboard = 2;
var topLeaderboardUsers = 3;

var LeaderboardUserList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(LeaderboardUserList, _Component);

  var _super = _createSuper(LeaderboardUserList);

  function LeaderboardUserList() {
    var _this$props$usersList;

    var _this;

    (0, _classCallCheck2.default)(this, LeaderboardUserList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isGuest", typeof window !== 'undefined' ? !(0, _insidedDataStorage.getInsidedData)('user').userid : true);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isCustomizing", false);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      usersList: (_this$props$usersList = _this.props.usersList) !== null && _this$props$usersList !== void 0 ? _this$props$usersList : [],
      isLoading: false
    });
    return _this;
  }

  (0, _createClass2.default)(LeaderboardUserList, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var searchQuery, queryParameters, tabTitle, fetchLoggedInUserSection, _yield$Promise$all, _yield$Promise$all2, usersList, leaderboardUser;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                searchQuery = typeof window !== 'undefined' ? window.location.search : '';
                queryParameters = _qs.default.parse(searchQuery, {
                  ignoreQueryPrefix: true
                });
                this.isCustomizing = 'customize' in queryParameters;
                this.setState({
                  isLoading: true
                });
                tabTitle = this.props.tabTitle;
                fetchLoggedInUserSection = this.props.showLoggedInUserSection && !this.isGuest;
                _context.next = 8;
                return Promise.all([this.fetchLeaderboardWidget(), fetchLoggedInUserSection ? this.fetchLoggedInLeaderboardUser(tabTitle) : undefined]);

              case 8:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 2);
                usersList = _yield$Promise$all2[0];
                leaderboardUser = _yield$Promise$all2[1];
                this.setState({
                  usersList: usersList,
                  currentUser: leaderboardUser,
                  isLoading: false
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "fetchLeaderboardWidget",
    value: function () {
      var _fetchLeaderboardWidget = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var res;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return _axios.default.get('/widget/pointsLeaderboard', {
                  params: {
                    period: this.props.tabTitle,
                    pageSize: this.props.maxResults,
                    excludeRoles: this.props.excludeUserRole,
                    showLink: this.props.showLink,
                    linkText: this.props.linkText
                  }
                });

              case 3:
                res = _context2.sent;

                if (!res.data) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return", res.data);

              case 6:
                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                this.setState({
                  isLoading: false
                });
                return _context2.abrupt("return", []);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));

      function fetchLeaderboardWidget() {
        return _fetchLeaderboardWidget.apply(this, arguments);
      }

      return fetchLeaderboardWidget;
    }()
  }, {
    key: "fetchLoggedInLeaderboardUser",
    value: function () {
      var _fetchLoggedInLeaderboardUser = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(period) {
        var res;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _axios.default.get('/leaderboard/fetchUser', {
                  params: {
                    period: period,
                    widget: true,
                    excludeRoles: this.props.excludeUserRole
                  }
                });

              case 3:
                res = _context3.sent;

                if (!(Object.keys(res.data).length !== 0)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", res.data);

              case 6:
                _context3.next = 12;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](0);
                this.setState({
                  isLoading: false
                });
                return _context3.abrupt("return", undefined);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 8]]);
      }));

      function fetchLoggedInLeaderboardUser(_x) {
        return _fetchLoggedInLeaderboardUser.apply(this, arguments);
      }

      return fetchLoggedInLeaderboardUser;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isPreviewEmptyMessage = _this$props.isPreviewEmptyMessage,
          emptyMessage = _this$props.emptyMessage,
          tabTitle = _this$props.tabTitle,
          linkText = _this$props.linkText,
          showLink = _this$props.showLink,
          showLoggedInUserSection = _this$props.showLoggedInUserSection;
      var _this$state = this.state,
          usersList = _this$state.usersList,
          isLoading = _this$state.isLoading,
          currentUser = _this$state.currentUser;
      var displayLoggedInUserSection = showLoggedInUserSection && !this.isGuest;
      return (0, _preact.h)("div", {
        className: "leaderboard-tab"
      }, isLoading ? '' : (0, _preact.h)("div", null, usersList.length > minUsersRequiredOnLeaderboard && (!this.isCustomizing || this.isCustomizing && !isPreviewEmptyMessage) ? (0, _preact.h)("div", {
        className: "leaderboard-widget-table-container"
      }, (0, _preact.h)("section", {
        className: "leaderboard-widget-table"
      }, (0, _preact.h)("div", {
        className: "leaderboard-widget-table-body"
      }, displayLoggedInUserSection && (0, _preact.h)(LeaderboardUserRow, {
        user: currentUser,
        customClass: "leaderboard-row-current-user",
        isLoggedInUser: true,
        isLoggedInUserSection: true
      }), usersList.map(function (user) {
        return (0, _preact.h)(LeaderboardUserRow, {
          key: user.id,
          user: user
        });
      })))) : (0, _preact.h)("div", {
        className: "default-leaderboard-meta-text",
        dangerouslySetInnerHTML: {
          __html: emptyMessage
        }
      }), showLink && (0, _preact.h)("div", {
        className: "leaderboard-link-text"
      }, (0, _preact.h)("a", {
        href: (0, _absoluteUrlRuntime.resolveUrl)("/leaderboard?period=".concat(tabTitle)),
        className: "btn--cta btn--show-more"
      }, ' ', linkText, (0, _preact.h)(_ChevronRight.default, {
        className: "leaderboard-link-text-icon",
        height: 20,
        width: 20
      })))));
    }
  }]);
  return LeaderboardUserList;
}(_preact.Component);

var LeaderboardUserRow = function LeaderboardUserRow(_ref) {
  var user = _ref.user,
      _ref$isLoggedInUser = _ref.isLoggedInUser,
      isLoggedInUser = _ref$isLoggedInUser === void 0 ? false : _ref$isLoggedInUser,
      _ref$isLoggedInUserSe = _ref.isLoggedInUserSection,
      isLoggedInUserSection = _ref$isLoggedInUserSe === void 0 ? false : _ref$isLoggedInUserSe,
      customClass = _ref.customClass;

  if (!user) {
    return null;
  }

  var id = user.id,
      name = user.name,
      avatar = user.avatar,
      points = user.points,
      leaderboardPosition = user.leaderboardPosition,
      rank = user.rank;
  var userData = (0, _utils.normalizeUserData)(id, name, avatar, rank, isLoggedInUser);
  var loggedInUserData = (0, _utils.normalizeUserData)(id, name, avatar, rank, isLoggedInUser, isLoggedInUserSection);
  var isMedalVisible = leaderboardPosition !== null && leaderboardPosition <= topLeaderboardUsers;
  var isTopThree = leaderboardPosition <= topLeaderboardUsers;
  var leaderboardPositionToDisplay = isLoggedInUserSection && (0, _utils.formatLeaderboardPosition)(leaderboardPosition, points);
  return (0, _preact.h)("div", {
    className: "leaderboard-row ".concat(customClass !== null && customClass !== void 0 ? customClass : '')
  }, (0, _preact.h)("div", {
    className: "leaderboard-user-position"
  }, isMedalVisible && (0, _preact.h)(_Medal.default, {
    className: "icon-medal mobile-medal-icon icon-medal-".concat(leaderboardPosition, " is-hidden-S is-hidden-L")
  }), (0, _preact.h)("span", {
    className: (0, _classnames.default)('position-number text--meta', isTopThree ? 'position-number-top' : 'position-number-other')
  }, leaderboardPosition), isLoggedInUserSection && (0, _preact.h)("div", {
    className: "logged-in-user-section-ranking-wrapper"
  }, (0, _preact.h)("div", {
    className: "logged-in-user-section-ranking"
  }, leaderboardPositionToDisplay), (0, _preact.h)("div", {
    className: "logged-in-user-section-ranking-label text--meta"
  }, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.header.ranking"
  })))), (0, _preact.h)("div", {
    className: "leaderboard-user-details"
  }, (0, _preact.h)("div", {
    className: "leaderboard-user-avatar"
  }, (0, _preact.h)(_UserAvatar.default, {
    user: userData,
    showRank: true,
    style: {
      display: 'block'
    }
  })), (0, _preact.h)("div", {
    className: "leaderboard-username"
  }, (0, _preact.h)("div", null, (0, _preact.h)(_UserName.default, {
    user: loggedInUserData,
    extraClass: "username"
  }), (0, _preact.h)("p", {
    className: "leaderboard-user-points is-hidden-only-M"
  }, (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "{n} point| {n} points",
    count: {
      n: points.toString()
    }
  }))))), (0, _preact.h)("div", {
    className: (0, _classnames.default)('leaderboard-user-points-M', 'is-hidden-S', 'is-hidden-L')
  }, ' ', (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "{n} point| {n} points",
    count: {
      n: points.toString()
    }
  })), isLoggedInUserSection && (0, _preact.h)("div", {
    className: "logged-in-user-section-points-wrapper"
  }, (0, _preact.h)("div", {
    className: "logged-in-user-section-points"
  }, points), (0, _preact.h)("div", {
    className: "logged-in-user-section-points-label text--meta"
  }, (0, _preact.h)(_phrase.default, {
    p: "leaderboard.header.points"
  }))), (0, _preact.h)("div", {
    className: "leaderboard-user-medal is-hidden-only-M"
  }, isMedalVisible && (0, _preact.h)(_Medal.default, {
    className: "icon-medal mobile-medal-icon icon-medal-".concat(leaderboardPosition)
  })));
};

var _default = LeaderboardUserList;
exports.default = _default;